import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { INotificationSetting } from '@curbnturf/entities';
import { Observable } from 'rxjs';
import { BASE_API_URL } from '../network/api-config';

const API_URL = `${BASE_API_URL}notification-settings`;

/**
 * Local fork of @curbnturf/user's UserNotificationsService — trimmed to
 * plain HttpClient. Full method set (both are used).
 */
@Injectable({ providedIn: 'root' })
export class UserNotificationsApiService {
  private readonly http = inject(HttpClient);

  fetchAll(): Observable<INotificationSetting[]> {
    return this.http.get<INotificationSetting[]>(`${API_URL}`);
  }

  update(notificationItem: INotificationSetting): Observable<INotificationSetting> {
    return this.http.post<INotificationSetting>(`${API_URL}`, notificationItem);
  }
}
